import React, { useReducer, useEffect, useCallback, useState, useRef, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import {
  Content,
  PageHeader,
  ButtonWithIcon,
  SmallInput,
  Label,
  LineUIVideo,
  LineReducer,
  LineSetContext,
  Button,
  Spinner,
  useTo,
  Icon,
  TextField,
  Form,
  useNotification,
  ButtonWithLoading,
  SliderInput,
  ISliderMark,
} from 'scorer-ui-kit';
import { useDevices } from '../hooks/useDevices';

import { executePipeline, getLines, saveLines } from '../lib/api_config';
import { useMovieList } from '../hooks/useMovieList';
import { add, format, max, startOfHour, startOfMinute } from 'date-fns';
import useQuery from '../hooks/useQuery';
import useDebounce from '../hooks/useDebounce';
import { secToMinHours, secToMins } from '../util';
import DateInput from '../components/DateInput';

const SLIDER_MAX_HOURS = 4;
const SLIDER_MAX_VALUE = SLIDER_MAX_HOURS * 60;
const DEFAULT_MINUTES = 10;

const PageContent = styled(Content)`
  margin-bottom: 20px;
  & > div {
    max-width: 1024px;
  }
`;

const ButtonsContainer = styled.div`
  padding-top: 23px;
  display: flex;
  justify-content: flex-start;
`;

const LineContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

const LineLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 188px;
`;

const LineRightContainer = styled.div`
  width: 620px;
  height: 390px;
  border-radius: 3px;
`;

const ReferenceLabel = styled.label`
  width: 218px;
  height: 17px;
  font-family: Lato;
  font-size: 14px;
  color: #5b636a;
  margin-bottom: 10px;
`;

const LineInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  height: 30px;
  margin-right: 21px;
`;

const InputIndex = styled(Label)`
  color: #5b636a;
  margin-right: 9px;
  width: 15px;
  height: 30px;
`;

const RemoveLink = styled.label`
  opacity: 0.4;
  font-family: Monorale;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08px;
  color: #0097ce;
  cursor: pointer;
  z-index: 1;
  margin-right: 21px;
  &:hover {
    opacity: 1;
  }
`;

const  ThumbnailWrapper= styled.div`
  position: relative;
  display: flex;
  margin: 20px 20px 20px 0;

  flex-direction: column;
  :not(:last-child):after {
    position: absolute;
    content: ' ';
    display: block;
    height: 2px;
    width: 20px;
    background-color: hsla(205, 22%, 66%, 45%);
    right: -20px;
    bottom: 40px;
  }
`;

const MovieTime = styled.div`
  /* width: 31px;
  height: 15px; */
  /* margin: 15px 39px 3px 5px; */
  font-family: Lato;
  font-size: 12px;
  font-weight: 500;
  color: hsla(195, 10%, 52%, 0.72);
  padding-bottom: 5px;
  padding-top: 15px;
`;
const MovieImg = styled.img`
  object-fit: cover;
  height: 55px;
  /* width: 42px; */
  border-radius: 4px;
  border: solid 2px hsla(205, 22%, 66%, 45%);
`;

const MovieList = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* height: 95px; */
  overflow-y: hidden;
  overflow-x: auto;
  max-width: 800px;
  height: 145px;
`;

const ButtonList = styled.div`
  button + button {
    margin-left: 10px;
  }
`;

const RemoveLabelContainer = styled.div`
  margin-top: 18px;
  margin-bottom: 7px;
  display: flex;
  justify-content: flex-end;
`;

const NewAnalysisForm = styled(Form)`
  margin-top: 70px;
  max-width: 800px;
`;
const IconRow = styled.div`
  display: flex;
  flex-direction: row;
  /* align-items: stretch; */
  margin-bottom: 65px;
  & > label {
    margin-bottom: 0;
    flex: 1;
  }
`;
const IconWrapper = styled.div`
  margin: 0 15px 6px;
`;
const IconHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid hsl(0, 0%, 93%);
  align-self: stretch;
  padding: 8px 20px 10px 0;
  margin: 0 36px 0 0;
`;

const IconLabel = styled.div`
  font-size: 14px;
  color: hsl(207, 5%, 57%);
  font-weight: medium;
  /* height: 16px;
  width: 47px; */
`;

const RangeRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const SliderWrapper = styled.div`
  flex-grow: 1;
  min-width: 200px;
`;

const SliderHeader = styled.div`
  font-size: 14px;
  color: hsl(207, 5%, 57%);
  display: flex;
  justify-content: space-between;
  padding: 0 6px;
  label {
    margin-bottom: 0;
    flex: 1;
  }
`;

const ValueLabel = styled(Label)`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  margin-bottom: 0;
  margin-left: 5px;
  display: inline-block;
`;

const Unit = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.data};
  color: hsla(195, 10%, 52%, 0.72);
  font-style: italic;
  font-size: 12px;
  line-height: 1.5;
  display: inline-block;
`;

const ValueTitle = styled.div`
  display: flex;
`;

const ValueUnitContainer = styled.div`
  width: 44px;
  text-align: right;
`;

const SpinnerWrapper = styled.div`
  margin: auto;
`;

const HiddenVideo = styled.video`
  display: none;
`;

const SliderContainer = styled.div`
  white-space: nowrap;
`;

const HeaderWrapper =styled.div`
  vertical-align: middle;
  & > div > div > h1 {
    line-height: 30px;
  }
`;

const IntroductionText = styled.p`
  text-align: left;
  font-size: 14px;
  font-weight: 300;
  line-height: 25px;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: hsla(207,5%,56.7%,1.000);
`;

interface Params {
  lid: string
}

export interface IVideoDuration {
  hours: number
  minutes: number
}

interface InitialState {
  isInitialTimeLoading: boolean
  durationInMin: number
}

const NewAnalysisJob: React.FC<{}> = () => {
  const [deviceName, setDeviceName] = useState<string>('');
  const { state: { devices }, actions: { fetchDevices } } = useDevices();
  const [state, dispatch] = useReducer(LineReducer, []);
  const { lid }: Params = useParams();
  const { t } = useTranslation(['NewAnalysisTask', 'Common']);
  const [videoSrc, setVideoSrc] = useState('');
  const to = useTo();
  const [showLines, setShowLines ] = useState(false);
  const { state: { movieList=[], loading: loadingMovies}, actions: { fetchMovieList } } = useMovieList(lid);
  const pageQuery = useQuery();
  const initialTime = pageQuery.get('initialTime');
  const [startTime, setStartTime] = useState<Date>(getInitialDate(initialTime));
  const [videoDuration, setVideoDuration] = useState<IVideoDuration>({hours:0, minutes: DEFAULT_MINUTES});
  const debounceDuration = useDebounce<IVideoDuration>(videoDuration, 500);
  const {sendNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const dateRef = useRef<HTMLDivElement>(null);
  const firstLoad = useRef<InitialState>(
    {
      isInitialTimeLoading: true,
      durationInMin:  DEFAULT_MINUTES
    });

  const lineOptions = {
    showHandleFinder: false,
    showSetIndex: false,
    showPointLabel: false,
    showHandle: true,
    showGrabHandle: true,
  };

  const fetchLines = useCallback(async() => {
    const lines = (await getLines(lid)||[]) ;

    dispatch({
      type: 'LOAD',
      state: lines
    });
  },
  [lid]);

  useEffect(() => {
    const {name = null} = devices.find((device) => device.lid === lid)||{};
    if (name) {
      setDeviceName(name);
    }
  }, [devices, lid]);

  useEffect(() => {
    const formatString = 'yyyy-MM-dd HH:mm';
    fetchMovieList({
      startDate: format(add(startTime, {minutes: -10}), formatString),
      endDate: format(add(startTime, {hours: debounceDuration.hours, minutes:debounceDuration.minutes}),formatString),
      reverse: true,
      pageSize: (debounceDuration.hours * 10 + 1).toString()
    });
  }, [debounceDuration, fetchMovieList, startTime]);

  useEffect(() => {
    fetchLines();
  }, [fetchLines]);


  useEffect(() => {
    fetchDevices();
  }, [fetchDevices]);

  useEffect(() => {
    const [{SignedMovieUrl= ''}={}] = movieList;
    setVideoSrc(SignedMovieUrl);
  }, [movieList]);

  const onFirstLoadedVideo = useCallback(({target}: SyntheticEvent<HTMLVideoElement>)=>{
    const {duration = null} = target as HTMLVideoElement;
    if(!duration) return;

    if(firstLoad.current && firstLoad.current.isInitialTimeLoading) {
      const validDuration = duration > (SLIDER_MAX_HOURS * 3600) ? (SLIDER_MAX_HOURS * 3600) : duration;
      const newDuration : IVideoDuration = secToMinHours(validDuration);
      const newMinDuration : number = secToMins(validDuration);
      firstLoad.current.isInitialTimeLoading = false;
      firstLoad.current.durationInMin = newMinDuration;
      setVideoDuration(newDuration);
    }

  },[]);

  const addLine = useCallback(() => {
    const randomPos = Math.floor(Math.random() * 300) + 1;
    const y1 = 100 + randomPos;
    const y2 = 100 + randomPos;
    const line = {
      name: 'Line 1',
      points: [
        {
          x: 60,
          y: y1
        },
        {
          x: 300,
          y: y2
        }
      ]
    };
    dispatch({
      type: 'ADD_SET',
      data: line
    });
  }, []);

  const renameLine = (value: string, index: number) => {
    dispatch({
      type: 'RENAME_SET',
      index: index,
      data: {
        name: value
      }
    });
  };

  const removeLine = (index: number) => {
    dispatch({
      type: 'REMOVE_SET',
      index
    });
  };

  const onStartAnalysis = useCallback(async() => {
    setLoading(true);
    try {
      await saveLines(lid, state);
    } catch(error ){
      if(error instanceof Error) {
        sendNotification({message: 'Error Saving Lines', type: 'error'});
        console.error('Error Saving Lines:', error.message);
      }

      setLoading(false);

      return;
    }
    try {
      const {pipelineExecutionID= null} = await executePipeline(
        lid,
        startTime.toISOString(),
        add(startTime, {hours: debounceDuration.hours, minutes:debounceDuration.minutes}).toISOString()
      );
      sendNotification({message: t('analysisStarted'), type: 'neutral'});
      console.debug('Pipeline Started', pipelineExecutionID);
      to(`/cameras/${lid}?tab=analysisJobs`)();
    } catch(error) {
      if(error instanceof Error) {
        console.error('Error Starting Pipeline:', error.message);
        sendNotification({message: 'Error Starting Job', type: 'error'});
      }

      setLoading(false);
    }
  },[debounceDuration, lid, sendNotification, startTime, state, to, t]);


  const handleDuration = useCallback((value: number) => {

    const hours = Math.floor(value / 60);
    const minutes = Math.floor(value % 60);
    const result: IVideoDuration = { hours, minutes };

    setVideoDuration(result);
  }, []);

  const getIntroductionText = () => {
    if(!showLines){
      if(i18n.language === 'ja'){
        return <IntroductionText>動画の<b>開始時刻</b>と<b>解析時間</b>を指定し、対象動画のサムネイルが表示されたら、<b>[次へ]</b> ボタンをクリックしてください。</IntroductionText>;
      } else {
        return <IntroductionText>Specify <b>Start Time</b> and <b>Duration</b>. Check that the thumbnails are correct. Then, hit <b>[Continue]</b> button</IntroductionText>;
      }
    } else {
      if(i18n.language === 'ja'){
        return <IntroductionText>検知線を設定し、［解析を開始］ボタンを押下してください。</IntroductionText>;
      } else {
        return <IntroductionText>Define your counter lines and reference here and press <b>Start Analysis</b> to commence this job.</IntroductionText>;
      }
    }
  };

  return (
    <PageContent>
      <HeaderWrapper>
        <PageHeader title={t('newAnalysisJob')} icon='Analyse' areaTitle={deviceName} areaHref={`/cameras/${lid}`} updateDocTitle={false} />
        {getIntroductionText()}
      </HeaderWrapper>
      {
        showLines === false ?
          <NewAnalysisForm>
            <IconRow>
              <IconHeader>
                <IconWrapper>
                  <Icon
                    icon='Camera'
                    size={18}
                    weight='regular'
                    color='dimmed'
                  />
                </IconWrapper>
                <IconLabel>{t('source')}</IconLabel>
              </IconHeader>

              <TextField
                style={{flex: 1}}
                name='deviceName'
                fieldState='disabled'
                label={t('Common:camera')}
                readOnly
                value={deviceName}
              />
            </IconRow>

            <IconRow>
              <IconHeader>
                <IconWrapper>
                  <Icon
                    icon='DateTime'
                    size={18}
                    weight='regular'
                    color='dimmed'
                  />
                </IconWrapper>
                <IconLabel>{t('range')}</IconLabel>
              </IconHeader>
              <RangeRow ref={dateRef}>
                <DateInput labelText={t('startTime')} date={startTime} callBackFunction={date => date instanceof Date && setStartTime(date)} />
                {((initialTime === null) || (!firstLoad.current.isInitialTimeLoading)) && (
                  <SliderWrapper>
                    <SliderHeader>
                      <Label htmlFor='duration-slider' labelText={`${t('duration')}`} />
                      <ValueTitle>
                        <ValueUnitContainer>
                          <ValueLabel htmlFor='duration-slider-hrs' labelText={videoDuration.hours.toString()} /><Unit>{t('hr')}</Unit>
                        </ValueUnitContainer>
                        <ValueUnitContainer>
                          <ValueLabel htmlFor='duration-slider-min' labelText={videoDuration.minutes.toString()} /><Unit>{t('min')}</Unit>
                        </ValueUnitContainer>
                      </ValueTitle>
                    </SliderHeader>
                    <SliderContainer>
                      <SliderInput
                        max={SLIDER_MAX_VALUE}
                        min={1}
                        defaultValue={firstLoad.current.durationInMin}
                        onChangeCallback={handleDuration}
                        marks={markGenerator()}
                      />
                    </SliderContainer>
                  </SliderWrapper>)}

              </RangeRow>
            </IconRow>


            <IconRow>
              <IconHeader>
                <IconWrapper>
                  <Icon
                    icon='Success'
                    size={18}
                    weight='regular'
                    color='dimmed'
                  />
                </IconWrapper>
                <IconLabel>{t('check')}</IconLabel>
              </IconHeader>

              <MovieList>
                {
                  loadingMovies ?
                    <SpinnerWrapper><Spinner size='large' styling='secondary' /></SpinnerWrapper>
                    :
                    movieList.map(({ SignedImageUrl, SignedMovieUrl, DateTime }, index) => (
                      <ThumbnailWrapper key={DateTime}>
                        <MovieTime title={DateTime}>{format(max([new Date(DateTime), startTime]), 'HH:mm')}</MovieTime>
                        <MovieImg src={SignedImageUrl || ''} />
                        {(index === 0) && <HiddenVideo preload='metadata' onLoadedMetadata={onFirstLoadedVideo} src={SignedMovieUrl} />}
                      </ThumbnailWrapper>
                    ))
                }
              </MovieList>
            </IconRow>

            <ButtonList>
              <Button design='secondary' onClick={to(`/cameras/${lid}`)}>{t('cancel')}</Button>
              <Button disabled={movieList.length < 1} onClick={() => setShowLines(true)}>{t('continue')}</Button>
            </ButtonList>
          </NewAnalysisForm>
          :
          <>
            <ButtonsContainer>
              <ButtonWithIcon onClick={() => addLine()} position='left' icon='Location' design='secondary' size='small'>{t('addLine')}</ButtonWithIcon>
            </ButtonsContainer>
            <LineContainer>
              <LineLeftContainer>
                <ReferenceLabel>{t('lineReferences')}</ReferenceLabel>
                {
                  state.map((line, index) =>
                    <React.Fragment key={index}>
                      <LineInputContainer>
                        <InputIndex htmlFor={'line' + index} labelText={`${index + 1}`} />
                        <SmallInput label='' id={'line' + index} onChange={(event) => renameLine(event.target.value, index)} placeholder={t('lineName')} value={line.name} />
                      </LineInputContainer>
                      <RemoveLabelContainer>
                        <RemoveLink onClick={() => removeLine(index)}>{t('remove')}</RemoveLink>
                      </RemoveLabelContainer>
                    </React.Fragment>
                  )
                }
              </LineLeftContainer>

              <LineRightContainer>
                <LineSetContext.Provider value={{ state, dispatch }}>
                  <LineUIVideo videoOptions={{loop: true, autoPlay: true}} src={videoSrc} options={lineOptions} />
                </LineSetContext.Provider>
              </LineRightContainer>
            </LineContainer>
            <ButtonsContainer>
              <div style={{'marginRight': '10px'}}>
                <Button design='secondary' onClick={() => setShowLines(false)}>{t('back')}</Button>
              </div>
              <ButtonWithLoading loading={loading} onClick={onStartAnalysis} position='left'>{t('startAnalysis')}</ButtonWithLoading>
            </ButtonsContainer>
          </>
      }
    </PageContent>
  );
};

export default NewAnalysisJob;

const getInitialDate = (dateQuery?: string | null): Date => {
  return dateQuery ? startOfMinute(new Date(dateQuery)) : startOfHour(new Date());
};

const markGenerator = (): ISliderMark[] => {
  const minuteText = i18n.language === 'ja' ? '分' : 'm';
  const hourText = i18n.language === 'ja' ? '時間' : 'hr';
  const marks: ISliderMark[] = [];

  marks.push({value:1, label:'1' + minuteText});

  for(let count = 1; count <= SLIDER_MAX_HOURS; count++) {
    const value = count * 60;
    marks.push({value, label:`${count}${hourText}`});
  }

  return marks;
};
